module.exports = __webpack_public_path__ + "img/404.0a5b619.png";